import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  serverTimestamp,
  addDoc,
  query,
  where,
  updateDoc,
  writeBatch,
  getFirestore,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { db, auth, storage } from "../services";
import { ref, uploadBytes, getDownloadURL, getStorage } from "firebase/storage";
import {
  EmailAuthProvider,
  getAuth,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  updatePassword,
} from "firebase/auth";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";

//get blogs by id
export const getBlogById = async (blogId) => {
  try {
    const blogRef = doc(db, "blogs", blogId);
    const blogSnap = await getDoc(blogRef);
    if (blogSnap.exists()) return blogSnap.data();
    throw new Error("Blog not found");
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

export const createBlog = async (newBlog, blogId) => {
  try {
    const blogRef = doc(db, "blogs", blogId);
    await setDoc(blogRef, {
      ...newBlog,
      id: blogId,
      updatedAt: serverTimestamp(),
    });
    toast("Blog added successfully!");
    return blogId;
  } catch (error) {
    console.error("Error adding blog:", error);
    toast.error("Failed to add blog.");
  }
}

export const getTestCaseById = async (testCasesId) => {
  try {
    if (!testCasesId) {
      console.error("No test case ID provided");
      return null;
    }
    const testCaseRef = doc(db, "testCases", testCasesId);
    const testCaseSnap = await getDoc(testCaseRef);
    if (testCaseSnap.exists()) {
      return testCaseSnap.data();
    }
    console.warn(`Test case with ID ${testCasesId} not found`);
    return null;
  } catch (error) {
    console.error("Error fetching test case:", error);
    return null;
  }
};

// get all bloggers
export const getAllBloggers = async () => {
  try {
    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map((doc) => doc.data().firstName);
  } catch (error) {
    console.error("Error fetching bloggers:", error);
    throw error;
  }
};

export const getAllManager = async () => {
  try {
    const auth = getAuth();
    const currentUserEmail = auth.currentUser?.email; // Get current user's email from Firebase Auth

    if (!currentUserEmail) {
      throw new Error("No current user logged in");
    }

    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);

    const excludedEmails = ["admin@exeonic.com", currentUserEmail]; // Exclude admin and current user

    return snapshot.docs
      .map((doc) => ({
        id: doc.id,
        data: doc.data().email, // Assuming email is in the `email` field
      }))
      .filter((user) => !excludedEmails.includes(user.data)); // Exclude admin and current user
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

// get all blogs filter type
export const getAllTypes = async () => {
  try {
    const usersCollection = collection(db, "blogFilters");
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map((doc) => doc.data().title);
  } catch (error) {
    console.error("Error fetching types:", error);
    throw error;
  }
};

// add blog


export const createTestCase = async (newTestCaseId, testCasesId) => {
  try {
    const testCaseRef = doc(db, "testCases", testCasesId);
    await setDoc(testCaseRef, {
      ...newTestCaseId,
      id: testCasesId,
      updatedAt: serverTimestamp(),
    });
    toast("Test case added successfully!");
    return testCasesId;
  } catch (error) {
    console.error("Error adding test case:", error);
    toast.error("Failed to add test case.");
  }
};

export const editTestCase = async (
  testCasesId,
  updatedTestCases,
  testCaseImageFile = null,
  testerImageFile = null
) => {
  try {
    if (testCaseImageFile) {
      const testCaseImageRef = ref(storage, `testCaseImages/${testCasesId}`);
      await uploadBytes(testCaseImageRef, testCaseImageFile);
      updatedTestCases.testCaseImage = await getDownloadURL(testCaseImageRef);
    }
    if (testerImageFile) {
      const testerImageRef = ref(storage, `testerImages/${testCasesId}`);
      await uploadBytes(testerImageRef, testerImageFile);
      updatedTestCases.testerImage = await getDownloadURL(testerImageRef);
    }
    const testCaseRef = doc(db, "testCases", testCasesId);
    await setDoc(
      testCaseRef,
      { ...updatedTestCases, updatedAt: serverTimestamp() },
      { merge: true }
    );
    toast("Test case updated successfully!");
  } catch (error) {
    console.error("Error updating test case:", error);
    throw new Error("Failed to update test case");
  }
};

//edit blog
export const editBlog = async (
  blogId,
  updatedBlog,
  blogImageFile = null,
  bloggerImageFile = null
) => {
  try {
    if (blogImageFile) {
      const blogImageRef = ref(storage, `blogImages/${blogId}`);
      await uploadBytes(blogImageRef, blogImageFile);
      updatedBlog.blogImage = await getDownloadURL(blogImageRef);
    }
    if (bloggerImageFile) {
      const bloggerImageRef = ref(storage, `bloggerImages/${blogId}`);
      await uploadBytes(bloggerImageRef, bloggerImageFile);
      updatedBlog.bloggerImage = await getDownloadURL(bloggerImageRef);
    }
    const blogRef = doc(db, "blogs", blogId);
    await setDoc(
      blogRef,
      { ...updatedBlog, updatedAt: serverTimestamp() },
      { merge: true }
    );
    toast("Blog updated successfully!");
  } catch (error) {
    console.error("Error updating blog:", error);
    throw new Error("Failed to update blog");
  }
};

//upload title blog image
export const uploadImage = async (file, blogId) => {
  try {
    const imageRef = ref(storage, `blogImages/${blogId}`);
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//upload blogger Image
export const uploadBloggerImage = async (file, blogId) => {
  try {
    const imageRef = ref(storage, `bloggerImages/${blogId}`);
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//delete blog
export const deleteBlog = async (blogId) => {
  try {
    await deleteDoc(doc(db, "blogs", blogId));
    toast("Blog deleted successfully!");
  } catch (error) {
    console.error("Error deleting blog:", error);
    toast.error("Failed to delete blog");
  }
};

export const getAllBlogs = async () => {
  const blogsCollection = collection(db, "blogs");
  const blogSnapshot = await getDocs(blogsCollection);
  const blogList = blogSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return blogList;
};

export const getAllTestCases = async () => {
  const testCasesCollection = collection(db, "testCases");
  const testCaseSnapshot = await getDocs(testCasesCollection);
  const testCaseList = testCaseSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return testCaseList;
};
export const deleteTestCase = async (testCaseId) => {
  try {
    await deleteDoc(doc(db, "testCases", testCaseId));
    toast("Test case deleted successfully!");
  } catch (error) {
    console.error("Error deleting test case:", error);
    toast.error("Failed to delete test case");
  }
};

export const signIn = async (email, password, designation) => {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);
    const userDoc = await getDoc(doc(db, "users", res.user.uid));

    if (!userDoc.exists()) {
      toast("User does not exist in the database.");
      auth.signOut();
      return null;
    }

    const user = userDoc.data();

    // if (!user.designation) {
    //   toast("User designation is missing.");
    //   auth.signOut();
    //   return null;
    // }

    // if (user.designation !== designation) {
    //   toast("User is not valid for this role.");
    //   auth.signOut();
    //   return null;
    // }

    return user;
  } catch (error) {
    console.error("Error in sign in:", error.message);
    toast(error.message);
  }
};

// get jobs by id
export const getJobById = async (careerId) => {
  try {
    const careerRef = doc(db, "careers", careerId);
    const careerSnap = await getDoc(careerRef);
    if (careerSnap.exists()) return careerSnap.data();
    throw new Error("Job not found");
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};
// get all jobs
export const getAllJobs = async () => {
  try {
    const jobsCollection = collection(db, "careers");
    const snapshot = await getDocs(jobsCollection);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};

//Add job
export const createJob = async (newJob) => {
  try {
    const docRef = await addDoc(collection(db, "careers"), {
      ...newJob,
      lastUpdated: serverTimestamp(),
    });
    console.log("Document written with ID: ", docRef.id);

    const jobRef = doc(db, "careers", docRef.id);
    await setDoc(jobRef, { id: docRef.id }, { merge: true });

    toast("Job added successfully!");
    return docRef.id;
  } catch (error) {
    console.error("Error adding Job:", error);
    toast.error("Failed to add Job.");
  }
};

export const editJob = async (jobId, updatedJob) => {
  try {
    const jobRef = doc(db, "careers", jobId);
    await setDoc(
      jobRef,
      { ...updatedJob, lastUpdated: serverTimestamp() },
      { merge: true }
    );
    toast("Job updated successfully!");
  } catch (error) {
    console.error("Error updating Job:", error);
    throw new Error("Failed to update Job");
  }
};

//delete job
export const deleteJob = async (jobId) => {
  try {
    await deleteDoc(doc(db, "careers", jobId));
    toast("Job deleted successfully!");
  } catch (error) {
    console.error("Error deleting Job:", error);
    toast.error("Failed to delete Job");
  }
};

//get all industries
export const getAllIndustries = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const industries = snapshot.docs.map((doc) => doc.data().industry);
    return industries.flat();
  } catch (error) {
    console.error("Error fetching Industries:", error);
    throw error;
  }
};

// get all roles
export const getAllRoles = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const roles = snapshot.docs.map((doc) => doc.data().role);
    return roles.flat();
  } catch (error) {
    console.error("Error fetching Role:", error);
    throw error;
  }
};

// get all job types
export const getAllJobType = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const jobTypes = snapshot.docs.map((doc) => doc.data().jobType);
    return jobTypes.flat();
  } catch (error) {
    console.error("Error fetching Role:", error);
    throw error;
  }
};

//get all offices
export const getAllOffices = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const office = snapshot.docs.map((doc) => doc.data().offices);
    return office.flat();
  } catch (error) {
    console.error("Error fetching Role:", error);
    throw error;
  }
};

//get all experience levels
export const getAllExperienceLevel = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const experienceLevels = snapshot.docs.map(
      (doc) => doc.data().experienceLevel
    );
    return experienceLevels.flat();
  } catch (error) {
    console.error("Error fetching Role:", error);
    throw error;
  }
};

// get all statuses
export const getAllStatus = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const statuses = snapshot.docs.map((doc) => doc.data().status);
    return statuses.flat();
  } catch (error) {
    console.error("Error fetching Status:", error);
    throw error;
  }
};

// get all designations
export const getAllDesignations = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const designations = snapshot.docs.map((doc) => doc.data().designation);
    return designations.flat();
  } catch (error) {
    console.error("Error fetching Designations:", error);
    throw error;
  }
};

// get all Leaves Type
export const getAllLeaveTypes = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const leaveTypes = snapshot.docs.map((doc) => doc.data().leaveType);
    return leaveTypes.flat();
  } catch (error) {
    console.error("Error fetching Leaves Type", error);
    throw error;
  }
};

//update applicants status
export const updateApplicantStatus = async (applicantId, status) => {
  try {
    const applicantRef = doc(db, "applicants", applicantId);
    await setDoc(applicantRef, { status }, { merge: true });
  } catch (error) {
    console.error("Error updating applicant status:", error);
    throw error;
  }
};

//apply for job
export const applyForJob = async (applicantData, careerId) => {
  try {
    const newApplicant = { ...applicantData, careerId };
    await addDoc(collection(db, "applicants"), newApplicant);
  } catch (error) {
    console.error("Error applying for job:", error);
  }
};

// get applicants by id
export const getApplicantsById = async (applicantsId) => {
  try {
    const applicantRef = doc(db, "applicants", applicantsId);
    const applicantSnap = await getDoc(applicantRef);
    if (applicantSnap.exists()) return applicantSnap.data();
    throw new Error("Applicant not found");
  } catch (error) {
    console.error("Error fetching Applicant:", error);
    throw error;
  }
};

//applicants by career id
export const getApplicantsByJobId = async (careerId) => {
  try {
    const applicantsCollection = collection(db, "applicants");
    const q = query(applicantsCollection, where("careerId", "==", careerId));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching applicants by job ID:", error);
    throw error;
  }
};

// Fetch all apllicants
export const getAllApplicants = async () => {
  try {
    const applicantsCollection = collection(db, "applicants");
    const snapshot = await getDocs(applicantsCollection);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching applicants:", error);
    throw error;
  }
};

//fetch all Employee

export const getAllEmployees = async (currentUserEmail) => {
  try {
    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);

    const users = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const currentUser = users.find((user) => user.email === currentUserEmail);

    if (!currentUser) {
      throw new Error("Current user not found.");
    }

    if (
      currentUser.designation === "EMPLOYEE" &&
      Array.isArray(currentUser.managedEmployees) &&
      currentUser.managedEmployees.length > 0
    ) {
      const managedUsers = users.filter((user) =>
        currentUser.managedEmployees.includes(user.id)
      );

      const managedUsersData = await Promise.all(
        managedUsers.map(async (user) => {
          const leavesCollection = collection(db, `users/${user.id}/leaves`);
          const leavesSnapshot = await getDocs(leavesCollection);

          const leavesData = leavesSnapshot.docs.map((leaveDoc) => ({
            leaveId: leaveDoc.id,
            ...leaveDoc.data(),
          }));

          return {
            ...user,
            leaves: leavesData,
          };
        })
      );

      return managedUsersData;
    }

    const employeesData = await Promise.all(
      users.map(async (user) => {
        const leavesCollection = collection(db, `users/${user.id}/leaves`);
        const leavesSnapshot = await getDocs(leavesCollection);

        const leavesData = leavesSnapshot.docs.map((leaveDoc) => ({
          leaveId: leaveDoc.id,
          ...leaveDoc.data(),
        }));

        return {
          ...user,
          leaves: leavesData,
        };
      })
    );

    return employeesData;
  } catch (error) {
    console.error("Error fetching employees based on role:", error);
    throw error;
  }
};

//fetch employee by id
export const getEmployeesById = async (employeeId) => {
  try {
    const employeeRef = doc(db, "users", employeeId);
    const employeeSnap = await getDoc(employeeRef);
    if (employeeSnap.exists()) return employeeSnap.data();
    throw new Error("Employee not found");
  } catch (error) {
    console.error("Error fetching Employee:", error);
    throw error;
  }
};

export const createEmployee = async (newEmployee) => {
  try {
    // Step 1: Create the user in Firebase Authentication
    const { email, password, ...employeeDetails } = newEmployee; // Extract email and password
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const userId = userCredential.user.uid;

    // Step 2: Fetch leave balances from meta data
    const metaDocRef = doc(db, "meta", "vhDROOX6liO88MKeMpYL"); // Replace with your meta document ID
    const metaSnap = await getDoc(metaDocRef);
    let leavesData = { al: 0, sl: 0, cl: 0, totalLeaves: 0 }; // Default values

    if (metaSnap.exists()) {
      leavesData = metaSnap.data().leavesData || leavesData;
    } else {
      console.warn("Meta document not found, using default leaves data.");
    }

    // Step 3: Add the employee document to Firestore with the `uid` as the document ID
    const employeeRef = doc(db, "users", userId);
    await setDoc(employeeRef, {
      ...employeeDetails, // Other employee details
      email, // Ensure email is stored
      leaveBalance: leavesData, // Leave balances
      lastUpdated: serverTimestamp(),
    });

    toast("Employee added successfully!");
    return userId;
  } catch (error) {
    console.error("Error adding Employee:", error);
    toast.error("Failed to add Employee.");
    throw error;
  }
};

//edit employee data
export const editEmployee = async (
  employeeId,
  updatedEmployee,
  employeeImageFile = null,
  degreeImageFile = null
) => {
  try {
    const employeeData = { ...updatedEmployee };

    if (employeeImageFile) {
      const employeeImageRef = ref(storage, `employeeImages/${employeeId}`);
      await uploadBytes(employeeImageRef, employeeImageFile);
      employeeData.image = await getDownloadURL(employeeImageRef);
    }

    if (degreeImageFile) {
      const degreeImageRef = ref(storage, `degreeImages/${employeeId}`);
      await uploadBytes(degreeImageRef, degreeImageFile);
      employeeData.degreeImage = await getDownloadURL(degreeImageRef);
    }
    delete employeeData.employeeImageFile;
    delete employeeData.degreeImageFile;
    const employeeRef = doc(db, "users", employeeId);
    await setDoc(
      employeeRef,
      { ...employeeData, lastUpdated: serverTimestamp() },
      { merge: true }
    );

    toast("Employee updated successfully!");
  } catch (error) {
    console.error("Error updating Employee:", error);
    throw new Error("Failed to update Employee");
  }
};

// upload employee image
export const uploadEmployeeImage = async (file, employeeId) => {
  try {
    const employeeImageRef = ref(storage, `employeeImages/${employeeId}`);
    await uploadBytes(employeeImageRef, file);
    return await getDownloadURL(employeeImageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//upload degree image
export const uploadDegreeImage = async (file, employeeId) => {
  try {
    const degreeImageRef = ref(storage, `degreeImages/${employeeId}`);
    await uploadBytes(degreeImageRef, file);
    return await getDownloadURL(degreeImageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//delete employee
export const deleteEmployee = async (employeeId) => {
  try {
    await deleteDoc(doc(db, "users", employeeId));
    toast("Employee deleted successfully!");
  } catch (error) {
    console.error("Error deleting Employee:", error);
    toast.error("Failed to delete Employee");
  }
};

// Update employee leave data
export const updateEmployeeLeaveData = async (employeeId, updatedLeaveData) => {
  try {
    const leavesCollectionRef = collection(db, `users/${employeeId}/leaves`);
    const leavesSnapshot = await getDocs(leavesCollectionRef);

    if (leavesSnapshot.empty) {
      throw new Error(
        `No leave data found for employee with ID: ${employeeId}`
      );
    }

    const leaveDocRef = leavesSnapshot.docs[0].ref;
    await updateDoc(leaveDocRef, {
      leavesData: updatedLeaveData.leavesData,
      status: updatedLeaveData.status,
    });

    console.log(
      `Successfully updated leave data for employee with ID: ${employeeId}`
    );
  } catch (error) {
    console.error("Error updating employee leave data:", error);
    throw error;
  }
};

export const approveLeave = async (
  employeeId,
  leaveId,
  updatedLeaveBalance
) => {
  try {
    const userRef = doc(db, `users/${employeeId}`);
    const leaveRef = doc(db, `users/${employeeId}/leaves`, leaveId);

    const batch = writeBatch(db);

    // Update user leave balance
    batch.update(userRef, { leaveBalance: updatedLeaveBalance });

    // Approve leave request
    batch.update(leaveRef, { status: "Approved" });

    // Commit batch updates
    await batch.commit();

    console.log(
      `Leave approved for employee ${employeeId}, leave ID: ${leaveId}`
    );
  } catch (error) {
    console.error("Error approving leave:", error);
    throw error;
  }
};

// Reject leave
export const rejectLeave = async (employeeId, leaveId) => {
  try {
    const leaveRef = doc(db, `users/${employeeId}/leaves`, leaveId);
    await updateDoc(leaveRef, {
      status: "Rejected",
    });

    console.log(
      `Leave with ID ${leaveId} for employee ${employeeId} has been rejected.`
    );
  } catch (error) {
    console.error("Error rejecting leave:", error);
    throw error;
  }
};

// Fetch leaves for a specific employee by employeeId
export const getLeavesByEmployeeId = async (userId) => {
  try {
    const leavesCollection = collection(db, `users/${userId}/leaves`);
    const snapshot = await getDocs(leavesCollection);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching leaves:", error);
    throw error;
  }
};

export const uploadCertificateImage = async (file, leaveId) => {
  try {
    const certificateImageRef = ref(storage, `employeeImages/${leaveId}`);
    await uploadBytes(certificateImageRef, file);
    return await getDownloadURL(certificateImageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

export const createLeaveRequest = async (leaveRequestData) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User is not authenticated.");
    }

    const employeeId = currentUser.uid;

    // Create the leave request in the user's leaves collection
    const leavesCollection = collection(db, `users/${employeeId}/leaves`);
    const newLeaveRef = await addDoc(leavesCollection, {
      ...leaveRequestData,
      userId: employeeId,
      createdAt: serverTimestamp(),
    });

    // Optionally add the leave ID to the document
    await setDoc(newLeaveRef, { leaveId: newLeaveRef.id }, { merge: true });

    console.log("Leave request created with ID:", newLeaveRef.id);
    toast("Leave request created successfully!");
  } catch (error) {
    console.error("Error creating leave request:", error);
    toast.error("Failed to create leave request.");
    throw error;
  }
};

export const getLeaveBalanceFromUserAndMeta = async (userId) => {
  try {
    const userDocRef = doc(db, `users/${userId}`);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      console.error("No such user document!");
      return { leavesData: {}, leaveBalance: {} };
    }

    const userData = userDocSnap.data();
    const leaveBalance = userData.leaveBalance || {};

    const metaDocRef = doc(db, `meta/vhDROOX6liO88MKeMpYL`);
    const metaDocSnap = await getDoc(metaDocRef);

    if (!metaDocSnap.exists()) {
      console.error("No such meta document!");
      return { leavesData: {}, leaveBalance };
    }

    const metaData = metaDocSnap.data();
    const leavesData = metaData.leavesData || {};

    return { leavesData, leaveBalance };
  } catch (error) {
    console.error("Error fetching leave data:", error);
    throw error;
  }
};

export const getCurrentUserProfile = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("No user is logged in");

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return userSnap.data();
    } else {
      throw new Error("User profile not found");
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const editCurrentUserProfile = async (
  updatedProfile,
  profileImageFile = null
) => {
  try {
    const auth = getAuth();
    const storage = getStorage();
    const db = getFirestore();

    const user = auth.currentUser;
    if (!user) throw new Error("No user is logged in");

    const userData = { ...updatedProfile };

    if (profileImageFile) {
      const profileImageRef = ref(storage, `profileImages/${user.uid}`);
      await uploadBytes(profileImageRef, profileImageFile);
      const downloadURL = await getDownloadURL(profileImageRef);
      userData.employeeImageUrl = downloadURL;
    }

    const userRef = doc(db, "users", user.uid);
    await setDoc(userRef, userData, { merge: true });

    return userData;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

//hr wikipedia
export const fetchCategories = async () => {
  try {
    const metaRef = collection(db, "meta");
    const metaSnapshot = await getDocs(metaRef);
    const metaData = metaSnapshot.docs.map((doc) => doc.data());
    const wikipediaCategories = metaData[0]?.wikipediaCategories || [];
    return wikipediaCategories;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const fetchBlogsByCategory = async (category) => {
  try {
    const hrWikipediaRef = collection(db, "hrWikipedia");
    const q = query(hrWikipediaRef, where("Category", "==", category));
    const snapshot = await getDocs(q);
    const blogs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return blogs;
  } catch (error) {
    console.error(`Error fetching blogs for category "${category}":`, error);
    return [];
  }
};

export const addHrBlog = async (blogData, hrBlogId) => {
  try {
    const hrWikipediaRef = doc(db, "hrWikipedia", hrBlogId);
    await setDoc(hrWikipediaRef, {
      ...blogData,
      id: hrBlogId,
      updatedAt: serverTimestamp(),
    });
    console.log("Blog updated successfully!");
    toast("Blog updated successfully!");
    return hrBlogId;
  } catch (error) {
    console.error("Error adding blog:", error);
    throw error;
  }
};

export const getHrBlogById = async (hrBlogId) => {
  try {
    const hrBlogRef = doc(db, "hrWikipedia", hrBlogId);
    const hrBlogSnap = await getDoc(hrBlogRef);
    if (hrBlogSnap.exists()) return hrBlogSnap.data();
    throw new Error("Blog not found");
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

export const editHrBlog = async (
  HrBlogId,
  updatedHrBlog,
  hrBlogImageFile = null
) => {
  try {
    if (hrBlogImageFile) {
      const hrBlogImageRef = ref(storage, `blogImages/${HrBlogId}`);
      await uploadBytes(hrBlogImageRef, hrBlogImageFile);
      updatedHrBlog.blogImage = await getDownloadURL(hrBlogImageRef);
    }
    const hrBlogRef = doc(db, "hrWikipedia", HrBlogId);
    await setDoc(
      hrBlogRef,
      { ...updatedHrBlog, updatedAt: serverTimestamp() },
      { merge: true }
    );
    toast("Blog updated successfully!");
  } catch (error) {
    console.error("Error updating blog:", error);
    throw new Error("Failed to update blog");
  }
};

export const deleteHrBlog = async (hrBlogId) => {
  try {
    await deleteDoc(doc(db, "hrWikipedia", hrBlogId));
    toast("Blog deleted successfully!");
  } catch (error) {
    console.error("Error deleting blog:", error);
    toast.error("Failed to delete blog");
  }
};

export const getHrAndAdminAuthors = async () => {
  try {
    const usersCollection = collection(db, "users");
    const hrAdminQuery = query(
      usersCollection,
      where("designation", "in", ["HR", "ADMIN"])
    );
    const snapshot = await getDocs(hrAdminQuery);
    return snapshot.docs.map((doc) => doc.data().firstName);
  } catch (error) {
    console.error("Error fetching HR and ADMIN bloggers:", error);
    throw error;
  }
};

export const getAllCategoriesTypes = async () => {
  try {
    const metaCollection = collection(db, "meta");
    const snapshot = await getDocs(metaCollection);
    const categories = snapshot.docs.map(
      (doc) => doc.data().wikipediaCategories
    );
    return categories.flat();
  } catch (error) {
    console.error("Error fetching Wikkipedia Categories", error);
    throw error;
  }
};

export const uploadHrImage = async (file, hrBlogId) => {
  try {
    const hrImageRef = ref(storage, `hrBlogImages/${hrBlogId}`);
    await uploadBytes(hrImageRef, file);
    return await getDownloadURL(hrImageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

export const getCurrentUser = async () => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error("No user is currently logged in.");
    }

    const userDocRef = doc(db, "users", currentUser.uid);
    const userSnapshot = await getDoc(userDocRef);

    if (!userSnapshot.exists()) {
      throw new Error("User data not found in Firestore.");
    }

    const userData = userSnapshot.data();

    return {
      designation: userData.designation,
    };
  } catch (error) {
    console.error("Error fetching current user data:", error);
    throw error;
  }
};

export const getLineManager = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) throw new Error("No user is logged in");

    const loggedInUserId = user.uid;

    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);

    const users = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const loggedInUser = users.find((user) => user.id === loggedInUserId);
    if (!loggedInUser) {
      console.error("Logged-in user not found");
      return [];
    }

    const managedEmployeesIds = loggedInUser.managedEmployees || [];

    const managedUserDetails = users
      .filter((user) => managedEmployeesIds.includes(user.id))
      .map((user) => ({
        name: user.firstName,
        empID: user.id,
        managerId: loggedInUserId,
        email: user.email,
      }));

    return managedUserDetails;
  } catch (error) {
    console.error("Error fetching managed employees:", error);
    throw error;
  }
};

export const getGoals = async (user) => {
  try {
    const userUid = getAuth().currentUser?.uid;

    if (!userUid) {
      toast.error("User not logged in.");
      return [];
    }

    const userRole = user?.designation;

    if (userRole === "ADMIN" || userRole === "HR") {
      const goalsQueryAll = query(collection(db, "goals"));
      const goalsSnapshotAll = await getDocs(goalsQueryAll);

      const goalsList = goalsSnapshotAll.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return goalsList;
    }

    const goalsQueryForEmp = query(
      collection(db, "goals"),
      where("empId", "==", userUid)
    );

    const goalsQueryForManager = query(
      collection(db, "goals"),
      where("managerId", "==", userUid)
    );

    const goalsSnapshotEmp = await getDocs(goalsQueryForEmp);
    const goalsSnapshotManager = await getDocs(goalsQueryForManager);

    const goalsList = [
      ...goalsSnapshotEmp.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      ...goalsSnapshotManager.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })),
    ];

    return goalsList;
  } catch (error) {
    console.error("Error fetching goals:", error);
    toast.error("Failed to fetch goals");
    return [];
  }
};

export const getGoalById = async (id) => {
  try {
    const goalDocRef = doc(db, "goals", id);
    const goalDoc = await getDoc(goalDocRef);
    if (goalDoc.exists()) {
      return { id: goalDoc.id, ...goalDoc.data() };
    } else {
      toast.error("Goal not found");
      return null;
    }
  } catch (error) {
    console.error("Error fetching goal:", error);
    toast.error("Failed to fetch goal");
    return null;
  }
};

export const createGoal = async (goalData) => {
  try {
    const newGoalRef = doc(collection(db, "goals"));
    const goalWithId = { ...goalData, id: newGoalRef.id };
    await setDoc(newGoalRef, goalWithId);
    toast.success("Goal created successfully");
    return newGoalRef.id;
  } catch (error) {
    console.error("Error creating goal:", error);
    toast.error("Failed to create goal");
    return null;
  }
};

// Function to edit an existing goal
export const editGoal = async (id, goalData) => {
  try {
    const goalDocRef = doc(db, "goals", id);
    await setDoc(goalDocRef, goalData, { merge: true });
    toast.success("Goal updated successfully");
  } catch (error) {
    console.error("Error editing goal:", error);
    toast.error("Failed to update goal");
  }
};

// Function to delete a goal
export const deleteGoal = async (id) => {
  try {
    await deleteDoc(doc(db, "goals", id));
    toast("Goal deleted successfully!");
  } catch (error) {
    console.error("Error deleting Goal:", error);
    toast.error("Failed to delete Goal");
  }
};

export const getContactedUsers = async () => {
  try {
    const usersCollection = collection(db, "contactedUsers");
    const snapshot = await getDocs(usersCollection);
    const usersList = snapshot.docs.map((doc) => doc.data());
    return usersList;
  } catch (error) {
    console.error("Error fetching contacted users:", error);
    throw error;
  }
};

export const getEmployeesBasedOnRole = async (currentUserEmail) => {
  try {
    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);

    const users = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const currentUser = users.find((user) => user.email === currentUserEmail);

    if (!currentUser) {
      throw new Error("Current user not found.");
    }

    if (
      currentUser.designation === "EMPLOYEE" &&
      Array.isArray(currentUser.managedEmployees) &&
      currentUser.managedEmployees.length > 0
    ) {
      const managedUsers = users.filter((user) =>
        currentUser.managedEmployees.includes(user.id)
      );

      const managedUsersData = await Promise.all(
        managedUsers.map(async (user) => {
          const leavesCollection = collection(db, `users/${user.id}/leaves`);
          const leavesSnapshot = await getDocs(leavesCollection);

          const leavesData = leavesSnapshot.docs.map((leaveDoc) => ({
            leaveId: leaveDoc.id,
            ...leaveDoc.data(),
          }));

          return {
            ...user,
            leaves: leavesData,
          };
        })
      );

      return managedUsersData;
    }

    const employeesData = await Promise.all(
      users.map(async (user) => {
        const leavesCollection = collection(db, `users/${user.id}/leaves`);
        const leavesSnapshot = await getDocs(leavesCollection);

        const leavesData = leavesSnapshot.docs.map((leaveDoc) => ({
          leaveId: leaveDoc.id,
          ...leaveDoc.data(),
        }));

        return {
          ...user,
          leaves: leavesData,
        };
      })
    );

    return employeesData;
  } catch (error) {
    console.error("Error fetching employees based on role:", error);
    throw error;
  }
};

export const updateManagedEmployees = async (newManagerEmail, userId) => {
  if (!newManagerEmail || !userId) {
    console.error("Missing required parameters.");
    return;
  }

  try {
    const usersCollection = collection(db, "users");

    const managersQuery = query(
      usersCollection,
      where("managedEmployees", "array-contains", userId)
    );
    const managersQuerySnapshot = await getDocs(managersQuery);

    for (const managerDoc of managersQuerySnapshot.docs) {
      const managerDocRef = doc(db, "users", managerDoc.id);
      await updateDoc(managerDocRef, {
        managedEmployees: arrayRemove(userId),
      });
    }

    const newManagerQuery = query(
      usersCollection,
      where("email", "==", newManagerEmail)
    );
    const newManagerQuerySnapshot = await getDocs(newManagerQuery);

    if (newManagerQuerySnapshot.empty) {
      console.error(`Manager with email ${newManagerEmail} does not exist.`);
      return;
    }

    const newManagerDocSnap = newManagerQuerySnapshot.docs[0];
    const newManagerDocRef = doc(db, "users", newManagerDocSnap.id);

    await updateDoc(newManagerDocRef, {
      managedEmployees: arrayUnion(userId),
    });

    const userDocRef = doc(db, "users", userId);
    await updateDoc(userDocRef, {
      lineManagerId: newManagerDocSnap.id,
    });

    console.log(`User ${userId} is now managed by ${newManagerDocSnap.id}`);
  } catch (error) {
    console.error("Error updating managed employees:", error.message);
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);

    toast.success(
      "Password reset email sent successfully. Please check your inbox."
    );

    return true;
  } catch (error) {
    console.error("Error in resetting password:", error.message);

    if (error.code === "auth/user-not-found") {
      toast.error("No user found with this email.");
    } else if (error.code === "auth/invalid-email") {
      toast.error("The email address is not valid.");
    } else {
      toast.error("An unexpected error occurred. Please try again.");
    }

    return false;
  }
};

export const resetPasswordManually = async (currentPassword, newPassword) => {
  try {
    const user = auth.currentUser;

    if (!user) {
      toast.error("User not authenticated. Please log in again.");
      return;
    }

    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    await reauthenticateWithCredential(user, credential);
    console.log("Reauthenticated user:", user.email);

    await updatePassword(user, newPassword);

    const usersRef = collection(db, "users");
    const q = query(usersRef, where("email", "==", user.email));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0];
      const userRef = doc(db, "users", userDoc.id);
      await updateDoc(userRef, { isFirstLogin: false });
      toast.success("Password has been reset successfully.");
    } else {
      toast.error("User document not found.");
    }
  } catch (error) {
    console.error("Error resetting password:", error.message);

    let errorMessage = "An error occurred while resetting the password.";

    if (error.code === "auth/wrong-password") {
      errorMessage = "Current password is incorrect.";
    } else if (error.code === "auth/too-many-requests") {
      errorMessage =
        "Too many failed attempts. Try again later or reset your password.";
    } else if (error.code === "auth/user-mismatch") {
      errorMessage =
        "The provided email does not match the logged-in user's email.";
    }

    toast.error(errorMessage);
  }
};
